import { Group } from '@/router/group.model';
import {
  overview,
  activities,
  conversions,
  transactionCenter
} from '@/router/routes/performance';

const routes = [overview, activities, conversions, transactionCenter];

const businessMetricsGroup = new Group(
  'Business Metrics',
  'business-metrics',
  routes,
  {
    superRoot: false,
    icon: 'activities',
    description:
      "Twism's Business Metrics tab monitors the progress of your rewards program and compares campaigns so you can make informed decisions."
  }
);

export { businessMetricsGroup };
export default businessMetricsGroup;
